export const RESOURCE_TYPE_INCOMING_MAIL_IS_AUTH_EXPIRED = 'mail_server_expiring';

export const INCOMING_MAIL_IS_AUTH_EXPIRED_RESOURCE_KEY = 'is_oauth_mail_server_expiring';

export const INCOMING_MAIL_IS_AUTH_EXPIRED_API =
	'/rest/internal/3/incomingMailServers/isOauthMailServersExpiring';
